import axios from 'axios';
import { environment } from '../environment/environment';

const BASE_URL = environment.baseUrl;

async function get(employerId) {
  const response = await axios.get(
    `${BASE_URL}/api/employer_features_config/ta/?employer_id=${employerId}`
  );
  return response.data;
}

async function update(employerId, config) {
  const response = await axios.put(
    `${BASE_URL}/api/employer_features_config/ta/?employer_id=${employerId}`,
    config
  );
  return response.data;
}

export const taConfigApiService = { get, update };
